import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function DataScientistSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["data-scientist"]} />;
}
